import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>CodeCruxDSA</h3>
            <p>Your complete DSA learning platform for AKTU 2nd Year</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#topics">Topics</a></li>
              <li><a href="#questions">Questions</a></li>
              <li><a href="#notes">Unit Notes</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect With Us</h4>
            <div className="social-links">
              <a href="https://linkedin.com/in/shaswat-shukla-a0724b3a8" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-linkedin"></i> LinkedIn
              </a>
              <a href="https://github.com/shaswat-shukla-dev" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-github"></i> GitHub
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li><a href="/my-account">My Account</a></li>
              <li><a href="mailto:shaswat.shukla.dev@gmail.com">shaswat.shukla.dev@gmail.com</a></li>
              
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 CodeCruxDSA. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
